import original_hotkeys from "hotkeys-js";

export const HOTKEYS_SCOPE = {
    UNAUTHORIZED: 'unauthorized' as const,
    WORKSPACE: 'workspace' as const,
    QUIZ_EDIT: 'quiz_edit' as const,
    MODAL: 'modal' as const,
    EDITOR: 'editor' as const,
    BREADCRUMBS: 'breadcrumbs' as const,
    CONTEXT_MENU: 'ctx_menu' as const,
}

export type HotkeysScopeValue = typeof HOTKEYS_SCOPE[keyof typeof HOTKEYS_SCOPE];

// allow hotkeys on form and contenteditable
original_hotkeys.filter = () => {
    return true;
}

original_hotkeys.setScope(HOTKEYS_SCOPE.UNAUTHORIZED)

export const hotkeys = original_hotkeys;


const previousScopes:HotkeysScopeValue[] = [];

export const setScope = (scope: HotkeysScopeValue) => {
    previousScopes.push(hotkeys.getScope() as HotkeysScopeValue);
    original_hotkeys.setScope(scope);
}

export const unsetScope = () => {
    const previousScope = previousScopes.pop();
    original_hotkeys.setScope(previousScope || HOTKEYS_SCOPE.WORKSPACE);
}

export type HotKeyOptions = {
    scope?: string;
    element?: HTMLElement | null;
    keyup?: boolean | null;
    keydown?: boolean | null;
    capture?: boolean
    splitKey?: string;
}